<template>
  <div>
    <v-hover v-if="!invisible" v-slot="{ hover }">
      <v-btn @click="openCropDialog()" rounded depressed height="41" :color="hover ? '#277faf' : null">
        <v-icon :color="hover ? 'white' : 'primary'">mdi-pencil</v-icon>
      </v-btn>
    </v-hover>
    <v-dialog v-model="cropDialog" fullscreen scrollable transition="dialog-bottom-transition">
      <v-card color="#2e3133" tile>
        <v-sheet
          color="transparent"
          max-width="100vw" max-height="calc(100vh - 60px)"
          height="calc(100vh - 60px)"
          class="d-flex flex-column align-center justify-space-around pb-5"
        >
          <div class="d-flex align-center flex-grow-1">
            <clipper-basic
              :src="cropItem.url"
              :rotate="cropItem.rotate"
              :scale="cropItem.scale / 100"
              :wrap-ratio="1"
              bg-color="#c9c9c9"
              ref="clipper"
            />
            <div class="pl-10">
              <v-slider
                vertical
                v-model="cropItem.scale"
                max="200"
                min="20"
                hide-details
                style="height: 100%"
              />
            </div>
          </div>
          <div style="width: 80%">
            <v-slider
              v-model="cropItem.rotate"
              :label="cropItem.rotate + '°'"
              max="180"
              min="-180"
              hide-details
            />
          </div>
          <div class="d-flex align-center justify-space-around" style="width: 90%">
            <v-btn fab dark @click="closeCropDialog()">
              <v-icon>mdi-undo-variant</v-icon>
            </v-btn>
            <v-btn fab dark @click="saveCrop()">
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </div>
        </v-sheet>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ImageEdit",
  props: {
    src: {
      type: [String, Object, File],
      default: null,
    },
    onEdit: {},
    getUpload: Boolean,
    id: {
      type: [Number, String],
      default: 0
    },
    invisible: Boolean,
  },
  computed: {
    ...mapGetters(['apiDomain']),
    type() {
      return this.src && this.src.slice(-3) === 'png' ? 'image/png' : 'image/jpeg'
    }
  },
  data: () => ({
    cropDialog: false,
    cropItem: {
      rotate: 0,
      scale: 100,
    }
  }),
  methods: {
    ...mapActions(['uploadFile']),

    async openCropDialog() {
      if (this.src) {
        if (typeof this.src === 'object') {
          await this.getBase64(await this.compressImage(this.src))
        }
        else {
          let temp = await fetch(this.apiDomain + '/' + this.src).then(r => r.blob())
          let file = new File([temp], "file", {type: this.type});
          this.cropItem.url = URL.createObjectURL(file)
          this.cropItem.rotate = 0
          this.cropItem.scale = 100
          this.cropDialog = true
        }
      }
    },

    compressImage(file) {
      return new Promise((resolve, reject) => {
        let img = new Image()
        img.src = URL.createObjectURL(file)
        let fileName = file.name.split('.')[0]
        img.onload = () => {
          let canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          let ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          canvas.toBlob(function (blob) {
            let f2 = new File([blob], fileName + ".jpeg");
            let xhr = new XMLHttpRequest();
            let form = new FormData();
            form.append("fileToUpload", f2);
            resolve(f2);
          }, 'image/jpeg', 0.5)
        }
      })
    },

    callFileReader(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (event) => {
          resolve(event.target.result)
        }
      })
    },

    async getBase64(file) {
      this.cropItem.url = await this.callFileReader(file)
      this.cropItem.rotate = 0
      this.cropItem.scale = 100
      this.cropDialog = true
    },

    closeCropDialog() {
      this.cropDialog = false
      this.cropItem.rotate = 0
      this.cropItem.scale = 100
    },

    async saveCrop() {
      const canvas = this.$refs.clipper.clip()
      let resultURL = canvas.toDataURL(this.type, 1)
      if (this.getUpload) {
        let formData = new FormData()
        formData.append('file', this.dataURLtoFile(resultURL, 'file'))
        await this.uploadFile({data: formData, use_case: 'cover'}).then(res => {
          if (this.onEdit) this.onEdit(res.data.url, this.id)
          this.closeCropDialog()
        })
      } else {
        if (this.onEdit) this.onEdit(resultURL, this.id)
        this.closeCropDialog()
      }
    },

    dataURLtoFile(url, filename) {
      let arr = url.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        str = atob(arr[1]),
        n = str.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = str.charCodeAt(n)
      }
      return new File([u8arr], filename, {type: mime})
    },

  }
}
</script>

<style scoped lang="scss">
:deep().vuejs-clipper-basic__stem-canvas {
  min-height: 40vh !important;
  min-width: 40vw !important;
  max-height: 80vh !important;
  max-width: 80vw !important;
}
</style>